import React from 'react';
import { Container } from './Container';
import { Label } from './Label';
import { Button } from './Button';
export function Hero() {
  return <section className="py-[clamp(80px,14vw,220px)] pb-[clamp(60px,10vw,140px)]" data-id="element-69" data-mp="eilex7b0aze3">
      <Container data-id="element-70" data-mp="9lla0zpw82ok">
        <Label data-id="element-71" data-mp="9l33995lu62e">A Creative Agency · Est. Atlanta</Label>
        <h1 className="mt-[28px] text-[clamp(3.5rem,11vw,11.5rem)] font-black leading-[0.88] tracking-[-0.035em]" data-id="element-72" data-mp="4mi3fau9loeh">
          Built for the people
          <br data-id="element-73" data-mp="127efjh2kpvf1" />
          building <span className="italic font-extrabold" data-id="element-74" data-mp="xae6qyecaek8">culture.</span>
        </h1>
        <p className="max-w-[720px] mt-[clamp(28px,4vw,48px)] text-[clamp(17px,1.4vw,22px)] leading-[1.45] text-[#1a1a1a]" data-id="element-75" data-mp="x8b7dnrar92u">
          The Abie Agency is a full-service creative shop for athletes, artists,
          founders, lawyers, and brands with something to say. Strategy,
          branding, social, content, web — we do all of it, and we do it like we
          mean it.
        </p>
        <div className="flex flex-wrap gap-[14px] mt-[clamp(28px,4vw,48px)]" data-id="element-76" data-mp="3814cjrqd82pe">
          <Button href="#work" variant="solid" data-id="element-77" data-mp="3j9tzsvxzjik8">
            See the work
          </Button>
          <Button href="/contact" variant="outline" data-id="element-78" data-mp="3o6kdjcmbi22h">
            Start a project
          </Button>
        </div>
      </Container>
    </section>;
}